import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';
import authentication from './modules/authentication'
import commons from './modules/commons'

import users from './modules/users'
import customers from './modules/customers'
import categories from './modules/categories'
import products from './modules/products'
import files from './modules/files'
import entity_files from './modules/entity_files'
import orders from './modules/orders'
import receipts from './modules/receipts'
import returns from './modules/returns'
import recharges from './modules/recharges'
import comments from './modules/comments'
import reports from './modules/reports'
import dashboard from './modules/dashboard'
import system_logs from './modules/system_logs'
import productInventory from './modules/productInventory'
import madeins from './modules/madeins'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    authentication,
    commons,
    users,
    customers,
    categories,
    products,
    files,
    entity_files,
    orders,
    receipts,
    returns,
    recharges,
    reports,
    comments,
    dashboard,
    system_logs,
    productInventory,
    madeins
  },
  state: {},
  mutations: {},
  actions: {},
  strict: false,
  plugins: [createPersistedState({paths:['authentication', 'commons', 'roles'], storage: window.localStorage})]
});
